/**
 * Mapea los datos de una venta desde el estado de la UI al formato exacto esperado por el API del Backend.
 * Utiliza el payload de referencia como "Fuente de Verdad" para asegurar que todas las llaves y tipos
 * de datos coincidan con el contrato del Backend.
 * 
 * @param {Object} data - Datos crudos del estado del carrito y UI.
 * @returns {Object} JSON formateado estrictamente para el contrato del Backend.
 */
export const mapSaleToApi = (data) => {
    const { tercero, methods, generateInvoice, total, items, taxes } = data;

    // 1. Mapeo del Tercero: Asegurar identifications_id y otros campos críticos
    const mappedTercero = {
        ...tercero,
        identifications_id: tercero?.identifications_id || tercero?.identificationsId,
    };

    // 2. Mapeo de Métodos de Pago: El backend espera el objeto con sus metadatos + value
    const mappedMethods = (methods || []).map(method => ({
        ...method,
        value: Number(method.value) // Asegurar que el valor sea numérico
    }));

    // 3. Mapeo de Items (Productos y Servicios): Se envían con todo su detalle de impuestos y discriminador
    const mappedItems = (items || []).map(item => ({
        ...item,
        is_service: Boolean(item.is_service ?? (item.type === 'service')),
        amount: Number(item.amount),
        total: Number(item.total),
        auxtax: Number(item.auxtax || 0)
    }));

    // 4. Construcción del Payload final siguiendo la Fuente de Verdad
    return {
        tercero: mappedTercero,
        methods: mappedMethods,
        generateInvoice: Boolean(generateInvoice),
        total: Number(total),
        items: mappedItems,
        taxes: taxes || [], // En el payload de verdad se incluyen los grupos de impuestos
        origin: data.origin || 'pos'
    };
};
